//期刊
<template>
  <div class="periodicals">
    <div class="periodicals-heda">
      <div class="periodicals-heda-img">
        <img src="../../assets/img/home/framework.png" />
      </div>
      <div class="periodicals-heda-text">{{ $t("i18n.HumanBrainForum") }}</div>
    </div>
    <!-- 内容 -->
    <div class="periodicals-contents">
      <div class="periodicals-contents-left">
        <img :src="imgURL + periodicalsObj.thumb" />
      </div>
      <div class="periodicals-contents-right">
        <div class="periodicals-contents-right-head">
          <span class="periodicals-contents-right-head-q">
            <!-- {{ $t("i18n.Resume") }} -->
            {{ periodicalsObj.title }}
          </span>
          <!-- <span class="periodicals-contents-right-head-j">
            {{ $t("i18n.Resume") }}12312
          </span> -->
        </div>
        <div
          v-if="periodicalsObj.contentBase"
          class="html"
          v-html="periodicalsObj.contentBase.content"
        ></div>
        <!-- <div
          class="periodicals-contents-right-box"
          @click="$router.push(`/periodicals?id=${periodicalsObj.id}`)"
        >
          <div class="periodicals-contents-right-box-img">
            <img src="../../assets/img/home/jiantou.png" />
          </div>
          <div class="periodicals-contents-right-box-name">
            {{ $t("i18n.Clickhereformorejournalinformation") }}
          </div>
        </div> -->
      </div>
    </div>
    <!-- 内容 -->
  </div>
</template>

<script>
export default {
  name: "periodicals",
  data() {
    return {
      periodicalsObj: { contentSingle: { content: [] } },
      imgURL: "",
      content: "",
    };
  },
  created() {
    this.newsHome();
    this.imgURL = localStorage.getItem("imgURL"); //切换中英文
  },
  methods: {
    // async getSingle() {
    //   const { data: data } = await this.$http.get("single", {
    //     params: {
    //       lang: localStorage.getItem("Language"),
    //       cate_id: "/periodicals",
    //     },
    //   });
    //   this.periodicalsObj = data.data;
    // },
    async newsHome() {
      const { data: data } = await this.$http.get("/brainpoolsIndex", {
        params: {
          page: 1,
          list_row: 10,
        },
      });
      if (data.data.data && data.data.data.length) {
        // this.resourceList = [];
        data.data.data.forEach((item) => {
          if (item.category_id == "人脑论坛") {
            this.periodicalsObj = item;
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.periodicals {
  //头部
  .periodicals-heda {
    margin: 58px 0;
    display: flex;
    justify-content: center;
    position: relative;
    .periodicals-heda-img {
      width: 214px;
      height: 24px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .periodicals-heda-text {
      position: relative;
      top: -10px;
      left: -7%;
      font-size: 20px;
      color: #393939;
      font-weight: 600;
    }
  }

  //内容
  .periodicals-contents {
    padding: 55px 260px 105px 245px;
    display: flex;
    background-color: #f6f6f6;
    .periodicals-contents-left {
      width: 287px;
      height: 342px;
      margin-right: 70px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .periodicals-contents-right {
      flex: 1;
      line-height: 2;
      .periodicals-contents-right-head {
        margin-bottom: 43px;
        .periodicals-contents-right-head-q {
          font-size: 24px;
          color: #393939;
          font-weight: 600;
          margin-right: 3px;
        }
        .periodicals-contents-right-head-j {
          font-size: 16px;
          color: #e06c55;
          font-weight: 600;
          margin-right: 3px;
        }
      }
      .periodicals-contents-right-text {
        display: flex;
        align-items: center;
        margin-bottom: 25px;
      }
    }
    .rectangular {
      width: 14px;
      height: 5px;
      background-color: #e06c55;
      margin-right: 5px;
    }
    .general-text {
      font-size: 16px;
      color: #e06c55;
      font-weight: 600;
    }

    .highlights-contents {
      font-size: 16px;
      color: #393939;
      margin-bottom: 40px;
    }
    .fields-contents {
      font-size: 16px;
      color: #393939;
    }

    .html {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 11;
      overflow: hidden;
    }
    .periodicals-contents-right-box {
      display: flex;
      margin-top: 40px;
      justify-content: flex-end;
      cursor: pointer;
      .periodicals-contents-right-box-img {
        width: 32px;
        height: 32px;
      }
      .periodicals-contents-right-box-name {
        font-size: 16px;
        color: #e06c55;
        border-bottom: 1px solid #e06c55;
      }
    }
  }
}
</style>
